import { render } from "./appAside.vue?vue&type=template&id=428446a2&scoped=true"
import script from "./appAside.vue?vue&type=script&lang=js"
export * from "./appAside.vue?vue&type=script&lang=js"

import "./appAside.vue?vue&type=style&index=0&id=428446a2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428446a2"]])

export default __exports__